<template>
  <v-container fluid>
    <list-editor
      :column-keys="columnKeys"
      :items="items"
      :loading="loading"
      :showSearchDate="true"
      :showExportButton="true"
      :totalItems="getTotalItems"
      :startDate="startDate"
      :endDate="endDate"
      :showPaymentStatus="true"
      :sourceName="sourceName"
      :getSearchKeys="searchKeys"
      :showSearchBar="true"
      @printData="printData"
      @changePage="changePage"
      @exportData="exportData"
      @changePaymentStatus="changePaymentStatus"
      @openDocument="openDocument"
      @searchData="searchData"
      @handleLoadData="handleLoadData"
    ></list-editor>

    <v-dialog
      :title="toolDialog.title"
      v-model="toolDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-text>
          <span>{{ toolDialog.text }}</span>
          <v-layout row wrap  v-if="editedItem.displayId">
            <v-flex xs12>
              <v-btn class="primary" dark text @click="toolEvent(18)">裕富線上撥款狀態</v-btn>
            </v-flex>
            <v-flex xs12 v-if="getUserInfo.enableQueryCaseStatus">
              <v-btn class="primary" dark text @click="toolEvent(19)">裕富線上案件狀態查詢</v-btn>
            </v-flex>
          </v-layout>

          <v-layout row wrap  v-if="editedItem.displayId">
            <v-flex xs12 v-if="getUserInfo.enableRequestSupplement">
              <v-btn class="primary" dark text @click="toolEvent(20)">裕富線上審件補件</v-btn>
            </v-flex>
            <v-flex xs12 v-if="getUserInfo.enableRequestForExam">
              <v-btn class="primary" dark text @click="toolEvent(21)">裕富線上案件申覆爭取</v-btn>
            </v-flex>
          </v-layout>

          <v-layout row wrap  v-if="editedItem.displayId">
            <v-flex xs12 v-if="getUserInfo.enableReCallout">
              <v-btn class="primary" dark text @click="toolEvent(22)">裕富線上案件重新照會</v-btn>
            </v-flex>
            <v-flex xs12>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="toolDialog.visible = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                @confirmEvent="messageDialog.confirm"></alert-view>

    <installment-payment-dialog
      :title="installmentDialog.title"
      :visible="installmentDialog.visible"
      :displayId="editedItem.displayId"
      :editIndex="installmentDialog.editIndex"
      :cellphone="editedItem.customer.cellphone"
      @closeEvent="closeDialogView"
      ></installment-payment-dialog>
  </v-container>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from "vuex";

import {
  getNow,
  exportFileToBlobUrl,
  installmentOnlineList
} from "../utils/tool";
import ListEditor from "../../components/ListEditor";
import common from "@/mixins/common";
import installmentPaymentDialog from '../../components/InstallmentPaymentDialog';
import ApplicationModel from '../../models/ApplicationModel';
import AlertView from '@/components/AlertView';

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "InstallmentPaymentView",
  components: {
    ListEditor,
    installmentPaymentDialog,
    AlertView
  },
  data() {
    return {
      sourceName:'InstallmentPaymentView',
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      startDate: "",
      endDate: "",
      searchKey: "",
      searchValue: "",
      selectedValue: 7,
      installmentDialog: {
        title: '',
        visible: false,
        editIndex: 0,
        confirm: () => {},
        cancel: () => {},
      },
      isMobile: md.phone(),
      loading: false,
      valid: true,
      dialog: false,
      editedItem: new ApplicationModel(),
      defaultItem: {
        caseType: 0, // 0優加 1優質 2一般 3借新還舊 4他行代償 5萬物代
        caseId: Math.uuidFast(),
        displayId: "",
        caseName: "機車原融",
        applyDate: {
          year: "",
          month: "",
          day: "",
          isRepublic: false,
          disabled: false,
        },
        approvedDate: {
          year: "",
          month: "",
          day: "",
          isRepublic: false,
          disabled: false,
        },
        name: "",
        memberId: "",
        birthday: {
          year: "",
          month: "",
          day: "",
          isRepublic: true,
        },
        cellphone: "",
        city: "",
        area: "",
        address: "",
        creditPrice: 0, // 貸款金額
        installmentsNumber: 12,
        creditPriceMonth: 0,
        totalCreditPrice: 0, // 總貸金額
        caseStatus: 0, // 0進件中 1婉拒 2待捕
        parentAgent: null,
        confirmAgent: null,
        createDate: getNow(),
        comment: "",
        agentId: "",
        confirmAgentId: "",
      },
      toolDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      search: {
        keyword: "",
      },
      items: [],
      caseId: "",
      syncToken: "",
      timeoutID: null,
    };
  },
  created() {

    const now = new Date();
    this.defaultItem.applyDate.year = `${now.getFullYear()}`;
    this.defaultItem.applyDate.month = `${
      now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
    }`;
    this.defaultItem.applyDate.day = `${
      now.getDate() + 1 < 10 ? `0${now.getDate() + 1}` : now.getDate() + 1
    }`;

    this.fetchAgentList().then(() => {
      this.editedItem.agentId = this.getUserInfo.agentId;
    });
    this.setDefualtDate();
  },
  mixins: [common],
  watch: {
    $route(to, from) {
      if (to.path.indexOf("FinanceCreditList") > -1) {
        this.timeoutID = setInterval(() => {
          this.loadData();
          console.log(`5分鐘刷新 ${getNow()}`);
        }, 5 * 60 * 1000);
      } else {
        if (this.timeoutID) {
          clearInterval(this.timeoutID);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    hasBeforeBank() {
      return this.editedItem.vendor && this.editedItem.vendor.productId === "2";
    },
    getTotalItems() {
      return this.totalItems;
    },
    columnKeys() {
      let list = [
        { value: 'requestPaymentURL', text: '請款文件', sortable: false, required: true , isShow:true , isEdit:false},
        {
          value: "print",
          text: "其他工具",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "name",
          text: "申辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "memberId",
          text: "身分證字號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPrice",
          text: "貸款金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "installmentsNumber",
          text: "總期數",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPriceMonth",
          text: "月付金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "productName",
          text: "專案名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "caseType",
          text: "顧客評分",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "applyDisplayDate",
          text: "申請日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        }, {
          value: "saveDate",
          text: "編輯日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        }, {
          value: "requestPaymentDate",
          text: "請款日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        }
      ];
      if (this.isAdmin) {
        return list;
      } else if (this.getUserInfo.enableLoanhfc === true) {
        return list.filter((m) => m.value !== "delete");
      }
      return list.filter(
        (m) => m.value !== "changeCase" && m.value !== "delete"
      );
    },
    dialogKeys() {
      return this.columnKeys.filter((m) => m.value !== "tools");
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    searchKeys() {
      return [
        { key: "name", value: "姓名" },
        { key: "memberId", value: "身分證字號" },
        { key: "displayId", value: "案件編號" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "getFinanceCreditNewList",
      "loginAgentService",
      "fetchAgentList",
      "fetchCreditProductInfo",
      "getFinanceCountInfo",
      "queryAppropriation",
      "queryCaseStatus"
    ]),
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    changePaymentStatus(value) {
      console.log(`changePaymentStatus ${value}`)
      this.selectedValue = value
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      const loginResult = await this.loginAgentService({
        email: this.getUserInfo.email,
      });
      this.syncToken = loginResult.data.data.token;

      let conditionArray = [{ "key" :"caseStatus" , "value":`${this.selectedValue}` }]

      console.log(`this.searchValue ${this.searchValue}`)

      if(this.searchValue) {
        const valueInfo = { "key":this.searchKey , "value":this.searchValue }
        conditionArray.push(valueInfo)
      }
      const dataInfo = {
        token: this.syncToken,
        agentId: this.isAdmin ? "" : this.getUserInfo.agentId,
        email: this.getUserInfo.email,
        startDate: `${this.startDate} 00:00:00`,
        endDate: `${this.endDate} 23:59:59`,
        searchKey:"",
        searchValue:"",
        pageIndex: this.pageIndex,
        limit: this.limit,
        searchQuery:conditionArray,
        showAll: true
      }
      console.log(`dataInfo ${JSON.stringify(dataInfo)}`)
      const results = await this.getFinanceCreditNewList(dataInfo);
      this.items = results.data.data.list;
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
      console.log(`items === ${JSON.stringify(this.items)}`);
    },
    async exportData() {
      this.loading = true;

      let conditionArray = [{ "key" :"caseStatus" , "value":`${this.selectedValue}` }]

      console.log(`this.searchValue ${this.searchValue}`)

      if(this.searchValue) {
        const valueInfo = { "key":this.searchKey , "value":this.searchValue }
        conditionArray.push(valueInfo)
      }
      const dataInfo = {
        token: this.syncToken,
        pageIndex: 1,
        limit: 10000,
        searchKey:"",
        searchValue:"",
        agentId: this.isAdmin ? "" : this.getUserInfo.agentId,
        email: this.getUserInfo.email,
        startDate: `${this.startDate} 00:00:00`,
        endDate: `${this.endDate} 23:59:59`,
        searchQuery:conditionArray,
        showAll: true
      }
      const results = await this.getFinanceCreditNewList(dataInfo);
      console.log(`result === ${JSON.stringify(results)}`)
      let columns = [
        {
          key: "productName",
          name: "專案別"
        },
        {
          key: "caseType",
          name: "顧客評分"
        },
        {
          key: "displayId",
          name: "案件編號"
        },
        {
          key: "name",
          name: "姓名"
        },
        {
          key: "memberId",
          name: "身分證字號"
        },
        {
          key: "installmentsNumber",
          name: "期數"
        },
        {
          key: "creditPriceMonth",
          name: "期付金"
        },
        {
          key: "totalPrice",
          name: "申貸金額"
        }]

      const resultList = results.data.data.list;
      for (let i in resultList) {
        let itemInfo = resultList[i]
        if (itemInfo.category === 2 && itemInfo.productId === "0") {
          itemInfo.productName = "商品貸原融";
        }
      }
      exportFileToBlobUrl("裕富線上請款匯出列表", columns, resultList);
      this.loading = false;
    },
    async toolEvent(index) {
      this.toolDialog.visible = false;
     if (index === 18) {
        this.loading = true;
        const param = {
          salesId: this.getUserInfo.salesId ? this.getUserInfo.salesId : '',
          displayId: this.editedItem.displayId
        }
        const result = await this.queryAppropriation(param);
        this.loading = false;
        const data = result.data
        const appropriations = data.data.appropriations
        let message = ''
        if (appropriations.length > 0) {
          const repayKindName = appropriations[0].repayKindName
          const status = appropriations[0].status
          message = installmentOnlineList(status)
        }

        this.showMessageDialog(
          '裕富線上撥款狀態',
          message,
          true,
          () => {},
          () => {}
        );
      } else if (index === 19) {
        this.loading = true;
        const param = {
          salesId: this.getUserInfo.salesId ? this.getUserInfo.salesId : '',
          displayId: this.editedItem.displayId,
          memberId: this.editedItem.customer.memberId
        }
        console.log(`裕富線上案件狀態查詢param ===${JSON.stringify(param)}`)
        const result = await this.queryCaseStatus(param);
        this.loading = false;
        const data = result.data
        console.log(`裕富線上案件狀態查詢 ===${JSON.stringify(data)}`)
        let message = ''
        message += `${this.editedItem.displayId} ${this.editedItem.customer.name} <br>`;
        const caseStatusItem = data.data;
        if(data.data.payment) {
          message += `${data.data.promoName} <br>`;
          message += `總貸金額 ${data.data.instCap} <br>`;
          message += `期數 ${data.data.payment[0].instNo} <br>`;
          message += `期付 ${data.data.payment[0].instAmt} <br>`;
          if (caseStatusItem.promoNo === 'DP22' || caseStatusItem.promoNo === 'DN82'){
            message += `<br>`;
            message += `預計撥付金額:<br>`;
            message += `${caseStatusItem.netBorrowToPayBackAmt ? caseStatusItem.netBorrowToPayBackAmt : '0'}<br>`;
            message += `預計結清金額:<br>`;
            message += `${caseStatusItem.borrowToPayBackAmt ? caseStatusItem.borrowToPayBackAmt : '0'}<br>`;
          }
          if (caseStatusItem.capitalApply && caseStatusItem.capitalApply.length > 0){
            message += `<br>`;
            message += `實撥金額<br>`;
            let i= 1 , total = 0;
            const findCustomer =  caseStatusItem.capitalApply.find(price=>price.payeeTypeName === '客戶');
            if (findCustomer){
              message += `撥款新案的剩餘金額<br>`;
              message += `撥款日期：${findCustomer.appropriateDate}<br>`;
              message += `撥款金額：${findCustomer.remitAmount}<br>`;
              message += `<br>`;
              total += parseInt(findCustomer.remitAmount, 10);
            }

            const findVendor =  caseStatusItem.capitalApply.find(price=>price.payeeTypeName === '裕富');
            if (findVendor){
              message += `前貸金額<br>`;
              message += `撥款日期：${findVendor.appropriateDate}<br>`;
              message += `撥款金額：${findVendor.remitAmount}<br>`;
              message += `<br>`;
              total += parseInt(findVendor.remitAmount, 10);
            }

            for (let price of caseStatusItem.capitalApply){
              if (price.payeeTypeName !== '裕富' && price.payeeTypeName !== '客戶'){
                message += `${i}<br>`;
              }
              message += `撥款日期：${price.appropriateDate}<br>`;
              message += `撥款金額：${price.remitAmount}<br>`;
              message += `<br>`;
              total += parseInt(price.remitAmount, 10);
              i++;
            }
            message += `<br>撥款總額：${total}<br>`;
          }
        } else {
          message = `尚無狀態<br>`
        }

        if (data.data.reasonSuggestionDetail &&
            data.data.reasonSuggestionDetail.length > 0) {
            message += `<br>`
            const dataDetail = data.data.reasonSuggestionDetail;
            for(const i in dataDetail) {
              const dataInfo = dataDetail[i]
              if(dataInfo["kind"]) {
                 message += `${dataInfo["kind"]}`
              }
              if(dataInfo["explain"]) {
                if(dataInfo["kind"]) {
                 message += ` : `
                }
                message += `${dataInfo["explain"]} <br>`
              } else {
                message += `<br>`
              }
              if(dataInfo["comment"]) {
                message += `${dataInfo["comment"]} <br><br>`
              }
            }
        }
         if (data.data.examineComment && data.data.examineComment !=='') {
           message += `備註說明：${data.data.examineComment} <br>`
         }
        if (data.data.customer && data.data.customer.length > 0) {
          const dataDetail = data.data.customer;
          if (dataDetail["calloutResult"]) {
            message += `<br>`;
            message += `${dataDetail["calloutResult"]["comment"]} <br>`
          }
        }

       if (data.data.code && data.data.code === 'E999'){
         message = `裕富回傳異常，請洽裕富相關人員`
       }
       this.showMessageDialog(
          '裕富線上案件狀態查詢',
          message,
          true,
          () => {},
          () => {}
        );
      } else if (index === 20) {
        this.installmentDialog.title = '裕富線上審件補件';
        this.installmentDialog.editIndex = 1;
        this.installmentDialog.visible = true;
        this.installmentDialog.confirm = () => {
          this.installmentDialog.visible = false;
        };
        this.installmentDialog.cancel = () => {
          this.installmentDialog.visible = false;
        };
      } else if (index === 21) {
        this.installmentDialog.title = '裕富線上案件申覆爭取';
        this.installmentDialog.editIndex = 2;
        this.installmentDialog.visible = true;
        this.installmentDialog.confirm = () => {
          this.installmentDialog.visible = false;
        };
        this.installmentDialog.cancel = () => {
          this.installmentDialog.visible = false;
        };
      } else if (index === 22) {
        this.installmentDialog.title = '裕富線上案件重新照會';
        this.installmentDialog.editIndex = 3;
        this.installmentDialog.visible = true;
        this.installmentDialog.confirm = () => {
          this.installmentDialog.visible = false;
        };
        this.installmentDialog.cancel = () => {
          this.installmentDialog.visible = false;
        };
      }
    },
    async printData(item) {
      console.log(`printData item === ${JSON.stringify(item)}`);
      this.rowItemInfo = item;
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId,
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        console.log(`this.editedItem  === ${JSON.stringify(this.editedItem)}`);
        this.toolDialog.visible = true;
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    closeDialogView() {
      this.installmentDialog.visible = false;
    },
    openDocument(url) {
      if(url !== '') {
        window.open(url, '_blank');
      }
    },
    searchData(searchInfo) {
      this.startDate = searchInfo.startDate
      this.endDate = searchInfo.endDate
      this.searchKey = searchInfo.searchKey
      this.searchValue = searchInfo.keyword
      this.loadData()
    },
    handleLoadData() {
      this.loadData()
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/web/InstallmentPaymentView.vue